import qs from 'qs';
import { serviceApi } from '../service';

const updateAppointmentDraft = (appointmentDraft) =>
  serviceApi.fetchJSON('appointment-draft', {
    method: 'PUT',
    body: appointmentDraft,
  });

export const getDecodedAppointmentDraft = (token) =>
  serviceApi.fetchJSON(`appointment-draft?${qs.stringify({ token }, { skipNulls: true })}`);

export const appointmentDraftApi = {
  updateAppointmentDraft,
  getDecodedAppointmentDraft,
};

export const getApiDraftFromReduxDraft = ({
  appointmentType,
  shop,
  partner,
  dateSlot,
  timeSlot,
  address,
  addressDescription,
  partnersGroupId,
  addons,
  products,
  fittingTypes,
  piercingType,
  selectedServiceTypeChanged,
}) => ({
  appointmentTypeId: appointmentType.id,
  localAppointmentTypeId: appointmentType.localId,
  fittingTypes,
  piercingType,
  selectedServiceTypeChanged: !!selectedServiceTypeChanged,
  storeId: shop.id,
  partnerId: partner.id,
  appointmentSlot: {
    date: dateSlot,
    time: timeSlot.from,
    eventId: timeSlot.eventId,
  },
  address,
  addressDescription,
  partnersGroupId,
  addons:
    addons &&
    addons
      .filter(({ appointmentType: addonAppointmentType }) => addonAppointmentType)
      .map(({ appointmentType: addonAppointmentType, timeSlot: time }) => ({
        id: addonAppointmentType.id,
        localId: addonAppointmentType.localId,
        slot: {
          date: dateSlot,
          time: time.from,
          eventId: time.eventId,
        },
      })),
  products:
    products && products.length
      ? products.map(({ id, quantity, information, selectionType, productId }) => ({
          id,
          quantity,
          information,
          selectionTypeId: selectionType ? selectionType.id : null,
          productId,
        }))
      : null,
});

export const getReduxDraftFromDecodedToken = ({
  appointmentType,
  store,
  partner,
  appointmentSlot,
  address,
  addressDescription,
  partnersGroupId,
  addons,
  products,
  fittingTypes,
  piercingType,
  selectedServiceTypeChanged,
}) => ({
  appointmentType: appointmentType || { id: '' },
  fittingTypes,
  piercingType,
  selectedServiceTypeChanged: !!selectedServiceTypeChanged,
  shop: store || { id: '' },
  partner: partner || { id: null },
  dateSlot: appointmentSlot ? appointmentSlot.date : '',
  timeSlot: appointmentSlot ? appointmentSlot.selectedTime : { from: 0, eventId: '' },
  address: address || null,
  addressDescription: addressDescription || null,
  partnersGroupId: partnersGroupId || '',
  addons:
    addons &&
    addons.map(({ appointmentType: addonAppointmentType, slot }) => ({
      appointmentType: addonAppointmentType,
      dateSlot: slot ? slot.date : '',
      timeSlot: slot ? slot.selectedTime : { from: 0, eventId: '' },
    })),
  products:
    products && products.length
      ? products.map(
          ({
            id,
            quantity,
            information,
            selectionType,
            type,
            name,
            adminTime,
            activityTime,
            productId,
          }) => ({
            id,
            quantity,
            information,
            type,
            name,
            adminTime,
            activityTime,
            selectionType,
            productId,
          }),
        )
      : [],
});
